/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  shareAxios.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:33
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import FDRequest from "fd-request";
import { AxiosError } from "axios";
import store from "@/store";
import { Toast, Notify } from "vant";
import router from "@/router";
// @ts-ignore
import { getAuthHeader } from "@/utils/request";
import { VueConstructor } from "vue";
import { VueAxios } from "@/utils/axios";
import { ContentType } from "@/constant/common";
// 项目管理 ID
export const ACCESS_KEY_ID = process.env.VUE_APP_ACCESS_KEY_ID;
// 项目管理秘钥
export const ACCESS_KEY_SECRET = process.env.VUE_APP_ACCESS_KEY_SECRET;

export interface Parameter {
  [prop: string]: any;
}

const toastRequest = Toast
const toastTip = Toast

const err = function (error: AxiosError) {
  if (error.response) {
    const data = error.response.data;
    // @ts-ignore
    const token = store.state.user.token;
    // 处理登录失效
    if (
      error.response.status === 401 &&
      !(data.result && data.result.isLogin)
    ) {
      toastTip.fail("登录信息已过期，请重新登录");
    } else if (error.response.status === 500) {
      toastRequest.clear();
      router.push("/500");
    } else if (error.response.status === 403) {
      toastTip.fail(data.message);
    } else {
      toastTip.fail(data.msg || "网络繁忙，请稍后再试");
    }
  }
  return Promise.reject(error);
};

const axiosShareAPIUrl = new FDRequest({
  mode: process.env.NODE_ENV as "production",
  encrypt: false,
  cancelRepeatRequest: true,
  config: {
    baseURL: process.env.VUE_APP_MANAGE_API_BASE_URL,
    timeout: 60000, // 请求超时时间
    headers: {
      clientId: "web",
      [ContentType]: "application/json",
      access_key_id: ACCESS_KEY_ID,
      access_key_secret: ACCESS_KEY_SECRET,
    },
  },
  errorHandle: err,
});

/**
 * 设置拦截器
 * @param axiosSet FDRequest实例
 */
const setInterceptor = function (axiosSet: FDRequest) {
  axiosSet.setRequestInterceptor(async (config: any) => {
    /* 添加加載中彈窗提示 start */
    let showLoading;
    if (config.hasOwnProperty("extraParams")) {
      showLoading = config.extraParams.hasOwnProperty("showLoading")
        ? config.extraParams.showLoading
        : true;
    } else {
      showLoading = true;
    }
    if (showLoading) {
      toastRequest.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
    }
    /* 添加加載中彈窗提示 end */

    // 移除传参中值为null或者undefined或者空字符串的属性
    if (config.params) {
      config.params = Object.keys(config.params).reduce((p, c) => {
        if (config.params[c] || config.params[c] === 0) {
          // @ts-ignore
          p[c] = config.params[c];
        }
        return p;
      }, {});
    }
    // @ts-ignore
    const token = store.state.share.shareToken;
    // @ts-ignore

    const userId = store.state.share.shareUserId;
    config.headers.userId = userId;
    config.headers.opUser = userId;
    if (token) {
      config.headers = { ...config.headers, ...getAuthHeader(token) }; // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    return config;
  });

  axiosSet.setResponseInterceptor(async (response: any) => {
    // console.log(response);
    /* 移除加載中彈窗提示 start */
    let showLoading;
    if (response.config.hasOwnProperty("extraParams")) {
      showLoading = response.config.extraParams.hasOwnProperty("showLoading")
        ? response.config.extraParams.showLoading
        : true;
    } else {
      showLoading = true;
    }
    if (showLoading) toastRequest.clear();
    /* 移除加載中彈窗提示 end */

    const result = response;
    const code = result.data.code
    if (code && code !== "000000" && code !== "000002") {
      toastTip.fail(result.data.msg);
      throw result;
    }
    return result.data;
  });
};

setInterceptor(axiosShareAPIUrl);

const serviceShareAPIUrl = axiosShareAPIUrl.service;

export {
  serviceShareAPIUrl as axiosShareAPIUrl
};
